import { type IconName } from '@dev-spendesk/grapes';

import { type StrictAuthMethods } from 'src/auth/modules/StrongCustomerAuthentication/models/factors';
import { TypeGuardError } from 'src/core/utils/switchGuard';

export function getAuthenticationMethodIcon(
  method: StrictAuthMethods,
): IconName {
  switch (method) {
    case 'TOTP':
      return 'password' as const;
    case 'SMS':
      return 'chat-bubble-ellipsis' as const;
    case 'EMAIL':
      return 'envelope' as const;
    default:
      throw new TypeGuardError(
        method,
        `Unknown authentication method ${method}`,
      );
  }
}
